<app-dialog [title]="title">
  <div content>
    {{message}}
  </div>
  <div class="flex gap-3 p-2" footer>
    <app-button (click)="onRejectButtonClick()" [color]="rejectButton.color" [icon]="rejectButton.icon"
                [label]="rejectButton.label" [raised]="rejectButton.raised"/>
    <app-button (click)="onAcceptButtonClick()" [color]="acceptButton.color" [icon]="acceptButton.icon"
                [label]="acceptButton.label" [raised]="acceptButton.raised" cdkFocusRegionstart/>
  </div>
</app-dialog>
